import { render, staticRenderFns } from "./ImportUsersModal.vue?vue&type=template&id=2a5f534a"
import script from "./ImportUsersModal.vue?vue&type=script&lang=js"
export * from "./ImportUsersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports